import React from "react";
import { ReactFlowProvider } from "@xyflow/react";

import BuilderTabs from "../../../Layouts/BuilderTabs";
import DBUser from "./DBUsers/DBUser";
import DBSchema from "./DBSchema/DBSchema";
import DBSettings from "./DBSettings";
import DBGroups from "./DBGroups";
import { useDBConnectorsContext } from "../../../context/DBConnectorContext";

const DBConfiguration = () => {
  const { selectedConnector } = useDBConnectorsContext();

  const tabData = [
    {
      label: "Users",
      content: <DBUser selectedConnectorId={selectedConnector.id} />
    },
    {
      label: "Tables",
      content: (
        <ReactFlowProvider>
          <DBSchema />
        </ReactFlowProvider>
      )
    },
    {
      label: "Views",
      content: <DBSchema onlyViews={true} />
    },
    {
      label: "Settings",
      content: <DBSettings selectedConnectorId={selectedConnector.id} />
    },
    {
      label: "Groups",
      content: <DBGroups selectedConnectorId={selectedConnector.id} />
    }
  ];

  return (
    <ReactFlowProvider>
      <BuilderTabs
        key={selectedConnector.id}
        tabs={tabData}
        containerClass="page-action-bar-top align-start"
        tabsClass="activity_tab"
      />
    </ReactFlowProvider>
  );
};

export default DBConfiguration;
